import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
import { Actions } from '../../actions';
import {
  RemoveFromArtistTeamSuccess,
  GetArtistsTeam,
} from '../action-creators';
import { REMOVE_FROM_ARTIST_TEAM_SUCCESS } from '../actions';

export const getArtistTeamAfterDeleteMemberEpic = (
  action$: Observable<Actions>
) =>
  action$.pipe(
    ofType<Actions, RemoveFromArtistTeamSuccess>(
      REMOVE_FROM_ARTIST_TEAM_SUCCESS
    ),
    map((action) => {
      return new GetArtistsTeam(action.artistId);
    })
  );
